import { Typography } from "antd";
const { Title } = Typography;

const Heading = ({ text, size, style }) => {
  return (
    <Title level={size} style={style}>
      {text}
    </Title>
  );
};

export default Heading;
